<template>
  <img
    v-if="globalStore.global.theme === 'LIGHT'"
    alt="banxa logo"
    src="@/assets/images/logos/banxa-logo-dark.png"
    class="logo logo-header__banxa__img"
  />

  <img
    v-else
    alt="banxa logo"
    src="@/assets/images/logos/banxa-logo-light.png"
    class="logo logo-header__banxa__img"
  />
</template>

<script setup>
import { useGlobalStore } from '@/stores/globalStore';

const globalStore = useGlobalStore();
</script>
